import { Modal as ModalComponent } from 'src/shared/design-system/Modal';
import styled from 'styled-components';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';
import { MODAL_TEXT } from './consts';

export const Modal = styled(ModalComponent)`
  max-height: 100vh;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;

  & [data-role='textarea-container'] {
    display: flex;

    & textarea {
      resize: none;
      min-height: 120px;
      max-height: 240px;
      max-width: 100%;
      width: 100%;
    }
  }

  &:not(:last-child) {
    margin-bottom: ${Spacing.SINGLE_HALF};
  }
`;

export const SubHeaderContainer = styled.div`
  margin-bottom: ${Spacing.SINGLE_HALF};
`;

export const SubHeader = styled.div`
  font-size: ${Font.Size.S};
  font-weight: 300;
  line-height: ${Font.LineHeight.XS};

  & + & {
    margin-top: ${Spacing.THREE_QUARTERS};
  }
`;

export const SectionHeader = styled.div`
  color: ${Colors.GRAY_DARK_30};
  font-size: ${Font.Size.S};
  font-weight: 600;
  line-height: ${Font.LineHeight.S};
  margin-bottom: ${Spacing.HALF};
`;

export const OptionalText = styled.span.attrs(() => ({
  children: MODAL_TEXT.OPTIONAL_TEXT,
}))`
  color: ${Colors.GRAY};
`;

export const UploadDropZoneContainer = styled.div`
  color: ${Colors.GRAY_DARK_10};
  font-size: ${Font.Size.L};
  font-weight: 600;
  line-height: ${Font.LineHeight.M};
  padding: ${Spacing.DOUBLE};
  text-align: center;
`;

export const UploadDropdownReplaceText1 = styled.span`
  font-weight: 400;
`;

export const UploadDropdownReplaceText2 = styled.span`
  color: ${Colors.AQUA};
`;

export const FooterContainer = styled.div`
  display: flex;
  gap: ${Spacing.SINGLE};
`;

export const ConfirmFooterContainer = styled(FooterContainer)`
  width: 100%;
  & button {
    flex: 1 1 100%;
    padding-left: ${Spacing.DOUBLE};
    padding-right: ${Spacing.DOUBLE};
  }
`;
